import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent implements OnInit {

  showSpinner: boolean = false;
  
  constructor(
    private spinnerService: SpinnerService
  ) { }

  ngOnInit(): void {
    this.initSpinner();
  }

  initSpinner() {
    this.spinnerService.getSpinnerObserver().subscribe((status: string) => {
      this.showSpinner = (status === 'start');
      // this.cdRef.detectChanges();
    });
  }

}
